module.exports = __webpack_public_path__ + "static/img/cargoplace.e234eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cargoplace.png
// module id = kLbK
// module chunks = 0